import {
  ApplicationConfig,
  Provider,
  provideZoneChangeDetection,
} from "@angular/core";
import { provideRouter, withHashLocation } from "@angular/router";
import { PucxPlataformaClientComponent } from "@pucomex-ng-infra/pucx-plataforma-client";
import { APP_ROUTES } from "./app.routes";
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideClsfAnalyticsRouterTracker } from "./shared/services/analytics.service";
export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(APP_ROUTES, withHashLocation()),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    provideClsfAnalyticsRouterTracker()
  ].concat(PucxPlataformaClientComponent.forRoot().providers as Provider[]),
};
